import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import Breadcrumb from "../../common/breadcrumb";
import CompanyListTable from "../../common/CompanyListTable";


const CompaniesList = () => {
    return (
        <Fragment>
            <Breadcrumb title="Company Configurations" parent="Setting" />

            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Company Configurations</h5>
                            </CardHeader>
                            <CardBody className="order-datatable">
                                {/* <BranchTable /> */}
                                <CompanyListTable />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default CompaniesList;
